exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".noImage_from_NoImagePlaceholder-css_Dr6 {\n  display: block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background: #EDECEE\n}\n.noImage_from_NoImagePlaceholder-css_Dr6 img {\n  width: 64px;\n  height: 64px;\n}\n.noImage_from_NoImagePlaceholder-css_Dr6 p {\n  position: absolute;\n  z-index: 2;\n  bottom: 8px;\n  left: 0;\n  width: 100%;\n  height: auto;\n  display: block;\n  color: #9f9ea9;\n  font-weight: 400;\n  font-size: 8.4px;\n  font-size: 0.525rem;\n  letter-spacing: 1.2px;\n  letter-spacing: 0.075rem;\n  text-transform: uppercase;\n  text-align: center;\n  word-wrap: normal;\n  white-space: nowrap;\n  text-overflow: clip;\n}\n", ""]);

// exports
exports.locals = {
	"noImage": "noImage_from_NoImagePlaceholder-css_Dr6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/components/item/NoImagePlaceholder.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/components/item/NoImagePlaceholder.css
// module chunks = 0